// extracted by mini-css-extract-plugin
export default {"zone":"StarterSuggestions_zone__x5L4s","strip":"StarterSuggestions_strip__ZIUiv","chip":"StarterSuggestions_chip__727LV"};